import { getClientId } from 'src/services/utils';

import { Client } from '../api-client';

const getBatchesUrl = (cohortId: string) => `v1/cohort/${cohortId}/batches`;

const getTeachersUrl = (cohortId: string) => `v1/cohort/${cohortId}/teachers`;

const getMetaUrl = (cohortId: string) => `v1/cohort/${cohortId}`;

const getCohortTestimonialsUrl = (cohortId: string) => `v1/cohort/${cohortId}/testimonials`;
const getBatchTestimonialsUrl = (batchSlug: string) => `v1/batches/${batchSlug}/testimonials`;

const getDetails = (batchSlug: string) => `v3/batches/${batchSlug}/details`;

const getDemoVideosUrl = (batchSlug: string) => `/v1/batches/${batchSlug}/demo-videos`;

const getTodayScheduleUrl = (batchSlug: string) => `v1/batches/${batchSlug}/todays-schedule`;

const getAnnouncementUrl = (batchSlug: string) => `v1/batches/${batchSlug}/announcement`;

const getRecentScheduleUrl = (batchSlug: string, subjectSlug: string) =>
  `v1/batches/${batchSlug}/subject/${subjectSlug}/recent-schedule`;

const getContentsUrl = (batchSlug: string, subjectSlug: string) =>
  `v2/batches/${batchSlug}/subject/${subjectSlug}/contents`;

const getTopicsUrl = (batchSlug: string, subjectSlug: string) =>
  `v2/batches/${batchSlug}/subject/${subjectSlug}/topics`;

const getTeacherDetailsUrl = (batchSlug: string, teacherId: string) =>
  `v1/batches/${batchSlug}/${teacherId}/teacher-details`;

const getPlansListUrl = (batchSlug: string) => `v1/batches/${batchSlug}/plans`;
const getEnrollStudentUrl = (batchId: string) => `v1/batches/${batchId}/enroll-student`;
const getUnenrollStudentUrl = (batchId: string) => `v1/batches/${batchId}/unenroll-student`;

const getMyBatchesUrl = () => 'batch-service/v4/batches/my-batches';
const getRecentWatchUrl = () => 'v3/video-stats/recent-watch';
const getLandingPageUrl = () => 'v1/cohort/landing-questions';
const getRecentCohortsUrl = () => 'v1/cohort/recent-cohorts';
const updateCohortUrl = () => 'v1/users/update-cohort';
const updateUserCohortUrl = () => 'v1/users';
const getUpdateRecentCohortUrl = () => 'v1/users/update-recent-cohort';
const getBatchBuyNowUrl = (batchSlug: string) => `v3/batches/${batchSlug}/buy-now`;
const getSuggestiveSearchUrl = (batchId: string, batchSubjectId: string) =>
  `v2/batches/${batchId}/subject/${batchSubjectId}/contents/search`;
const getPathshalaDetailsUrl = (batchId: string) => `v1/batches/${batchId}/pathshala-details`;
const getPayByWalletUrl = (orderId: string) => `v1/orders/${orderId}/pay-via-wallet`;
const getCohortSubscriptionUrl = () => 'v1/users/get-cohort-subscription';
const getPackageListUrl = () => 'v1/packages';
const createPackageFeeUrl = () => 'v1/packages/create-package-fee';
const addonsUrl = (batchId: string) => `v1/batches/${batchId}/addons`;
const activeTabUrl = (batchId: string) => `v1/batches/${batchId}/active-tabs`;

export const batchesFetcher = ({ queryKey, pageParam = 1 }: any) => {
  const { contentType, cohortId, limit } = queryKey[1];

  const params: any = {
    page: pageParam,
    contentType,
    limit,
  };
  return Client.get(getBatchesUrl(cohortId), {
    params,
  });
};

export const teacherFetcher = ({ queryKey, pageParams = 1 }: any) => {
  const { cohortId } = queryKey[1];
  return Client.get(getTeachersUrl(cohortId));
};

export const batchMetaFetcher = ({ queryKey }: any) => {
  const { cohortId } = queryKey[1];
  const _cohortId = cohortId || (localStorage.getItem('cohortId') as string);
  return Client.get(getMetaUrl(_cohortId));
};

export const cohortTestimonialFetcher = ({ queryKey, pageParam = 1 }: any) => {
  const { cohortId } = queryKey[1];
  return Client.get(getCohortTestimonialsUrl(cohortId));
};

export const addonsFetcher = ({ queryKey }: any) => {
  const { batchId, params } = queryKey[1];
  return Client.get(addonsUrl(batchId), { params });
};
export const batchTestimonialFetcher = ({ queryKey, pageParam = 1 }: any) => {
  const { cohortId } = queryKey[1];
  return Client.get(getBatchTestimonialsUrl(cohortId));
};

export const detailsFetcher = ({ queryKey }: any) => {
  const { batchSlug } = queryKey[1];
  return Client.get(getDetails(batchSlug));
};

export const demoVideoFetcher = ({ queryKey }: any) => {
  const { batchSlug } = queryKey[1];
  return Client.get(getDemoVideosUrl(batchSlug));
};

export const teacherDetailFetcher = ({ queryKey }: any) => {
  const { teacherId, batchSlug } = queryKey[1];
  return Client.get(getTeacherDetailsUrl(batchSlug, teacherId));
};

export const todayScheduleFetcher = ({ queryKey }: any) => {
  const { batchSlug } = queryKey[1];
  return Client.get(getTodayScheduleUrl(batchSlug));
};

export const announcementFetcher = ({ queryKey, pageParam = 1 }: any) => {
  const { batchSlug } = queryKey[1];
  return Client.get(getAnnouncementUrl(batchSlug));
};

export const recentScheduleFetcher = ({ queryKey, pageParam = 1 }: any) => {
  const { batchSlug, subjectSlug } = queryKey[1];
  return Client.get(getRecentScheduleUrl(batchSlug, subjectSlug));
};

export const contentsFetcher = ({ queryKey, pageParam = 1 }: any) => {
  const { batchSlug, subjectSlug, contentType, tag, isSubjectiveExercise } = queryKey[1];
  const params = {
    page: pageParam,
    contentType,
    tag,
    isSubjectiveExercise,
  };

  return Client.get(getContentsUrl(batchSlug, subjectSlug), {
    params,
  });
};

export const topicsFetcher = ({ queryKey, pageParam = 1 }: any) => {
  const { batchSlug, subjectSlug } = queryKey[1];
  const params = {
    page: pageParam,
  };

  return Client.get(getTopicsUrl(batchSlug, subjectSlug), {
    params,
  });
};

export const plansListFetcher = ({ queryKey, pageParam = 1 }: any) => {
  const { batchSlug } = queryKey[1];

  return Client.get(getPlansListUrl(batchSlug));
};

export const enrollStudentFetcher = ({ batchId, params }: any) => {
  if (!params.formId) {
    delete params.formId;
  }
  return Client.get(getEnrollStudentUrl(batchId), { params });
};
export const unenrollStudentFetcher = ({ queryKey }: any) => {
  const { batchId } = queryKey[1];
  return Client.get(getUnenrollStudentUrl(batchId));
};

export const myBatchesFetcher = ({ queryKey }: any) => {
  const { params } = queryKey[1];
  return Client.get(getMyBatchesUrl(), {
    params: { ...params, mode: 1, sort: 'TAG_LIST' },
  });
};
export const recentWatchFetcher = ({ queryKey }: any) => {
  const { params } = queryKey[1];
  return Client.get(getRecentWatchUrl(), { params });
};
export const landingQuestionFetcher = () => {
  const config = {
    headers: {
      organizationId: getClientId(),
    },
  };
  return Client.get(getLandingPageUrl(), config);
};
export const recentCohortsFetcher = () => {
  return Client.get(getRecentCohortsUrl());
};
export const updateCohortFetcher = (data: any) => {
  return Client.put(updateCohortUrl(), data);
};
export const updateUserCohortFetcher = (data: any) => {
  return Client.put(updateUserCohortUrl(), data);
};
export const updateRecentCohortFetcher = ({ cohortId }: any) => {
  return Client.put(getUpdateRecentCohortUrl(), { cohortId });
};

export const suggestiveSearchFetcher = ({ queryKey }: any) => {
  const { batchId, batchSubjectId, params } = queryKey[1];
  return Client.get(getSuggestiveSearchUrl(batchId, batchSubjectId), {
    params,
  });
};

export const batchBuyNowFetcher = ({ queryKey }: any) => {
  const { batchSlug } = queryKey[1];
  return Client.get(getBatchBuyNowUrl(batchSlug));
};

export const pathshalaDetailsFetcher = ({ queryKey }: any) => {
  const { batchId } = queryKey[1];
  return Client.get(getPathshalaDetailsUrl(batchId));
};

export const payByWalletFetcher = (payload: any) => {
  const { orderId, ...data } = payload;

  return Client.post(getPayByWalletUrl(orderId), { ...data });
};

export const getCohortSubscriptionFetcher = ({ queryKey }: any) => {
  const { params } = queryKey[1];
  return Client.get(getCohortSubscriptionUrl(), { params }).then((res: any) => res?.data);
};

export const getPackageListFetcher = ({ queryKey }: any) => {
  const { params } = queryKey[1];
  return Client.get(getPackageListUrl(), { params }).then((res: any) => res?.data);
};

export const createPackageFeeFetcher = (payload: any) => {
  return Client.post(createPackageFeeUrl(), payload);
};

export const activeTabFetcher = ({ queryKey }: any) => {
  const { batchId, params } = queryKey[1];
  return Client.get(activeTabUrl(batchId), { params });
};
